import {Typography} from '@mui/material';
import {FC} from 'react';

import {FormatCurrency} from 'components/currency/format-currency';
import {FormatUsdCurrency} from 'components/currency/format-usd-currency';
import {useUser} from 'context/user';
import {formatCurrency} from 'core/locale';
import {convertBrlToUsd} from 'utils/currency/exchange-rate';

type PriceWithUsdProps = {
    brlAmount: number;
    exchangeRate?: number | null;
};

export const PriceWithUsd: FC<PriceWithUsdProps> = ({brlAmount, exchangeRate}) => {
    const {user} = useUser();
    const usdAmount = convertBrlToUsd(brlAmount, exchangeRate);

    if (!user?.permissions.viewPrices) {
        return <>--- USD</>;
    }

    if (usdAmount === null) {
        return <FormatCurrency number={brlAmount} />;
    }

    return (
        <>
            <Typography component='span' variant='body2' fontWeight={500}>
                <FormatUsdCurrency number={usdAmount} />
            </Typography>
            <Typography component='span' variant='caption' display='block' color='textSecondary'>
                {formatCurrency(brlAmount, {}, {currencySymbol: 'BRL'})}
            </Typography>
        </>
    );
};
